<template>
    <div class="grid">
        <div class="grid-item select-source-option">
            <v-icon icon="eye"/>
            <r-button @click="selectCamera">Take a picture</r-button>
        </div>
        <div class="select-source-divisor">
            <span class="text-muted">OR</span>
        </div>
        <div class="grid-item select-source-option">
            <v-icon icon="caret-up"/>
            <v-file-selector accept="image/*" @input="processFileSource">
                <r-button
                    slot-scope="{openFileBrowser}"
                    @click="openFileBrowser">Browse for Images</r-button>
            </v-file-selector>
        </div>
    </div>
</template>

<script>
    import {vIcon, vFileSelector} from '@/components/form';

    export default {
        name: 'select-source-form-step',
        inject: ['registerAction', 'stepKey', 'goNextStep'],
        components: {
            vIcon,
            vFileSelector,
        },
        props: {
            attributeName: {
                type: String,
                required: true,
            },
        },
        date() {
            return {
                source: null,
            };
        },
        methods: {
            selectCamera() {
                this.setSource('camera');
            },
            processFileSource(fileList) {
                this.setSource('file', fileList[0]);
            },
            setSource(type, object) {
                this.source = {type, object};
                this.goNextStep();
            },
            submit() {
                this.$emit('input', this.source);
                return this.source;
            },
            register() {
                const action = {
                    attributeName: this.attributeName,
                    delegated: this.submit,
                };
                this.registerAction(this.stepKey, action);
            },
        },
        mounted() {
            this.register();
        },
    };
</script>
